import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";

export const Settings = () => {
    document.title = "Ayarlar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Ayarlar</h2>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"profile"}>Profil</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"rates"}>Tariflər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"payment"}>Ödəniş</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"control"}>Yoxlama</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"stocks"}>Anbarlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"owners"}>İstifadəçilər</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"departments"}>Şöbələr</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"templates"}>Şablonlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"spenditems"}>Xərc maddələri</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
